import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../../button";
import { ManageVendorDetails } from "../../details/manage-vendor/manage-vendor-details.component";

const options = [
    { value: 'apple', label: 'Apple' },
    { value: 'banana', label: 'Banana' },
    { value: 'orange', label: 'Orange' },
    { value: 'pear', label: 'Pear' },
  ];

export class ManageVendorModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show}=this.state;

    return(
      <>

    
      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="user-pen-light" iconSize="17px" customClassName="header-filter-button" labelName={this.props.labelName}/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch finance-detail-table"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <ManageVendorDetails/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>ADD</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
